import Vuex from 'vuex'
import Vue from 'vue'
import cmpModule from './modules/components'
import userModule from './modules/user'
import projectModule from './modules/project'
import mapModule from './modules/map'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
let persistanceKeys = ['project.currentProject', 'map.mapScope', 'project.otfComment']

const store = new Vuex.Store({
  plugins: [createPersistedState({
    paths: persistanceKeys
  })],
  modules: {
    cmp: cmpModule,
    user: userModule,
    project: projectModule,
    map: mapModule
  }
})


export default store




// WEBPACK FOOTER //
// ./src/store/index.js